import { call, put, select, takeLatest } from 'redux-saga/effects';
import requestWrapper from 'utils/requestWrapper';
import { UPLOAD_MEDIA_FILE } from './constants';
import {
  uploadCameraMediaFileSuccess,
  uploadCameraMediaFileError,
} from './actions';
import _local from 'utils/localStorageUtils';

export function* uploadCameraMediaFileSaga(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield _local.getLocalUser();
    const { file, fileType } = action;

    let result = false;

    if (fileType !== 'video') {
      result = yield requestWrapper(
        'POST-FORM-DATA',
        'media/upload/',
        file,
        currentUser.token,
      );
    } else {
      result = yield requestWrapper(
        'POST-FORM-DATA',
        'media/upload-video/',
        file,
        currentUser.token,
      );
    }

    if (result) {
      yield put(uploadCameraMediaFileSuccess(result, fileType));
    }
  } catch (err) {
    yield put(uploadCameraMediaFileError(err));
  }
}

// Individual exports for testing
export default function* uploadCameraMediaSaga() {
  yield takeLatest(UPLOAD_MEDIA_FILE, uploadCameraMediaFileSaga);
}
